let _userRoles: UserRoles | null = null;

export default class UserRoles {
  static get instance() {
    if (!_userRoles) {
      _userRoles = new UserRoles();
    }
    return _userRoles;
  }

  static get default() {
    return UserRoles.instance.roles;
  }

  private _data = {
    adminRole: 'admin',
    roles: {
      admin: 'Admins',
    } as Hash<string>,
  };

  get roles() {
    return this._data.roles;
  }

  set roles(roles: Hash<string>) {
    const newRoles: Hash<string> = {};
    Object.keys(roles).forEach(key => {
      const value = String(roles[key] || '');
      if (value) {
        newRoles[key] = value;
      }
    });
    this._data.roles = newRoles;
  }

  get adminRole() {
    return this._data.adminRole;
  }

  set adminRole(key: string) {
    this._data.adminRole = String(key || '') || 'admin';
  }

  freeze() {
    Object.freeze(this._data);
  }
}
